// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-select[data-v-121dd93a]{border-bottom:1px solid #e9ecef;display:flex;gap:20px;margin:0 20px;padding:20px 0}@media screen and (max-width:985px){.filter-select[data-v-121dd93a]{gap:16px;padding:16px 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
